import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { SpaceCapacityModelImpl } from './models/space-capacity-model';
import { SpaceInfoModelImpl } from './models/space-info-model';
import { SpacePermissionModelImpl } from './models/space-permission-model';
import { SpaceApiImpl } from './repository/space-api';
import { SpaceApi } from './types/space-api.interface';
import { SpaceCapacityModel } from './types/space-capacity.interface';
import { SpaceInfoModel } from './types/space-info.interface';
import { SpacePermissionModel } from './types/space-permission.interface';
import { SpaceSettingModel } from './types/space-setting.interface';
import { SpaceSettingModelImpl } from './models/space-setting-model';
import { SpaceService } from './types/space-service.interface';
import { SpaceServiceImpl } from './space-service';
export const space = new ContainerModule(bind => {
    bind(SpaceService).to(SpaceServiceImpl);
    bind(SpaceInfoModel).to(SpaceInfoModelImpl);
    bind(SpaceSettingModel).to(SpaceSettingModelImpl);
    bind(SpaceCapacityModel).to(SpaceCapacityModelImpl);
    bind(SpacePermissionModel).to(SpacePermissionModelImpl);
    bind(SpaceApi).to(SpaceApiImpl);
});
